import AdminContentAreaContainer from "../../AdminContentAreaContainer/AdminContentAreaContainer";
import "./AdminSettings.sass";
import TransparenctUrl from "./TransparencyUrl/TransparenctUrl";

function AdminSettings() {
  const histories = [{ title: "Home", link: "/admin" }];

  return (
    <AdminContentAreaContainer
      histories={histories}
      title="Application Settings"
    >
      <div className="admin-home">
        <div className="group">
          <div className="row-item">
            <div className="left">
              <div className="title">Transparency Page URL</div>
              <div className="description">
                The URL for the Transparency page. This page is used to provide
                information about the data collected by the application.
              </div>
            </div>
            <div className="right">
              <TransparenctUrl />
            </div>
          </div>
        </div>
      </div>
    </AdminContentAreaContainer>
  );
}

export default AdminSettings;
